import * as mutationTypes from 'store/mutationTypes'
import utils from 'src/utils/utils'

/**
 * @return {Promise}
 */
export const addMiniToast = function ({ commit }, toast) {
  toast.id = utils.generateGuid()
  toast.timeout = toast.timeout || 2000

  return commit(mutationTypes.ADD_MINI_TOAST, toast)
}

/**
 * @return {Promise}
 */
export const removeMiniToast = function ({ commit }, toast) {
  return commit(mutationTypes.REMOVE_MINI_TOAST, toast)
}



// WEBPACK FOOTER //
// ./src/store/modules/miniToasts/actions.js